import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import InPersonInfoSession from "../../../../src/components/discover/inpersonIS";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faChevronCircleRight,
  InPersonInfoSession,
  React
};